export default __webpack_public_path__ + "static/media/template-3.a70ba7ef.png";